/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_AuthorInputs */

const ja_metadata_author = /** @type {(inputs: Metadata_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン`)
};

const en_metadata_author = /** @type {(inputs: Metadata_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN" |
*
* @param {Metadata_AuthorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const metadata_author = /** @type {((inputs?: Metadata_AuthorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_AuthorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_author(inputs)
	return en_metadata_author(inputs)
});